import React from 'react';
import { CATEGORY_FAMILIES } from '../../services/categoryPricing';
import { usd } from './cashMoney';

// Codes come from the approved catalog returned by this distributor's settings, never a guess.
export function categoryProductLabel(family, products = []) {
  const codes = [
    ...new Set(
      products
        .filter((product) => product.familyKey === family.familyKey)
        .flatMap((product) =>
          typeof product.name === 'string'
            ? [...product.name.matchAll(/\((Q\d{4})\)/g)].map((match) => match[1])
            : []
        )
    ),
  ];
  return codes.length === 1 ? `${family.label} (${codes[0]})` : family.label;
}

export default function CategoryPricingCard({ settings, t }) {
  const rates = settings.pricingBasis === 'piece' ? settings.categoryRates : [];
  return (
    <fieldset className="me-cash-card">
      <legend>{t('Your Product Pricing')}</legend>
      <dl className="me-cash-category-prices">
        {CATEGORY_FAMILIES.map((family) => {
          const rate = rates.find((row) => row.familyKey === family.familyKey);
          return (
            <div key={family.familyKey}>
              <dt>{categoryProductLabel(family, settings.products)}</dt>
              <dd>
                {rate ? (
                  <>
                    <strong>{usd(rate.pricePerPieceCents)}</strong> <span>{t('per unit')}</span>
                  </>
                ) : (
                  <span>{t('Not configured')}</span>
                )}
              </dd>
            </div>
          );
        })}
      </dl>
      <p>{t('Your MedEffects price per physical piece, for every size. Shipping is separate.')}</p>
    </fieldset>
  );
}
